/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { DriversState, initialState } from '@drivers/store/drivers.state';
import * as DriversActions from './drivers.actions';

export function driversReducer(state = initialState, action: DriversActions.DriversActions): DriversState {
  switch (action.type) {
    case DriversActions.LOAD_DRIVERS_SUCCESS:
      return {
        ...state,
        drivers: action.drivers,
        isActionPending: false
      };
    case DriversActions.LOAD_DRIVERS:
    case DriversActions.LOAD_DRIVER:
    case DriversActions.PERSIST_DRIVER:
      return {
        ...state,
        isActionPending: true
      };
    case DriversActions.LOAD_DRIVER_SUCCESS:
      return {
        ...state,
        isActionPending: false,
        currentDriver: action.driver
      };
    case DriversActions.PERSIST_DRIVER_SUCCESS:
    case DriversActions.PERSIST_DRIVER_FAILURE:
    case DriversActions.LOAD_DRIVER_FAILURE:
    case DriversActions.LOAD_DRIVERS_FAILURE:
      return {
        ...state,
        isActionPending: false
      };
    default:
      return state;
  }
}
